import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarHistoryReportService {
  constructor(public http: HttpClient) {}

  addCarHistory(formObj: any) {
    return this.http.post(`${environment().api}/car/add/history`, formObj);
  }

  getCarHistory(formObj: any) {
    return this.http.post(`${environment().api}/car/get/history`, formObj);
  }

  deleteCarHistory(formObj: any) {
    return this.http.post(`${environment().api}/car/delete/history`, formObj);
  }
}
